import React from 'react'

import { Access } from '../../lib'
import * as state from '../../states'
import { TOfferSpendHistory } from '../../types'
import { IUiTableConfig, UiTable, UiDateInfo } from '../ui'
import * as helpers from '../../helpers'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'
import { useAtomValue } from 'jotai'

type IOfferSpendHistoryListTableProps = {
	items: Array<TOfferSpendHistory>;
	skip: number;
}

export const OfferSpendHistoryListTable = (props: IOfferSpendHistoryListTableProps) => {
	const {
		items = [],
		skip = 0,
	} = props
	const { t } = useTranslation()
	const profile = useAtomValue(state.profileAtom)
	const $access = new Access(profile ?? null)

	/*{
		"at": "2025-08-29",
		"amount": "500.00000",
		"offerId": 3110,
		"accountId": 76,
		"updatedAt": "2025-08-29T09:38:37.565Z"
	}*/

	const offerListTableConfig: IUiTableConfig<TOfferSpendHistory>[] = [
		{
			key: 'offerId',
			title: t(ALL_LANG_KEY.offer_spend_list_table.column_offer_id),
		},
		{
			key: 'accountId',
			title: t(ALL_LANG_KEY.offer_spend_list_table.column_account_id),
		},
		{
			key: 'at',
			title: t(ALL_LANG_KEY.offer_spend_list_table.column_date),
			rowCellFormatter: ({ value, rowData }) => {
				return (
					<UiDateInfo value={value} />
				)
			}
		},
		{
			key: 'updatedAt',
			title: t(ALL_LANG_KEY.offer_spend_list_table.column_date_updated),
			rowCellFormatter: ({ value, rowData }) => {
				return (
					<UiDateInfo value={value} />
				)
			}
		},
		{
			key: 'amount',
			title: t(ALL_LANG_KEY.offer_spend_list_table.column_amount),
			rowCellFormatter: ({ value, rowData }) => {
				const formatValue = helpers.formatAmount(value)

				return <>{helpers.thousandSeparator(formatValue)}</>
			}
		}
	]

	return <>
		<UiTable
			data={items}
			config={offerListTableConfig}
			// TODO: uncomment if necessary
			// classesToAdd={{
			// 	wrapper: 'table-sticky-wrapper table-sticky-wrapper--top-60',
			// }}
		/>
	</>
}